export const LISTING_ROWS_PER_PAGE = 10;
